import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";

const mockOrders = [
  {
    _id: "12345",
    totalAmount: 150,
    createdAt: "2024-09-01T10:00:00Z",
    status: "shipped",
    trackingId: "TRACK12345",
    products: [
      {
        productId: "p1",
        productName: "Blue Varsity Jacket",
        productImage: "https://via.placeholder.com/100",
        quantity: 1,
        price: 76
      },
      {
        productId: "p2",
        productName: "Red Hoodie",
        productImage: "https://via.placeholder.com/100",
        quantity: 2,
        price: 37
      }
    ]
  },
  {
    _id: "67890",
    totalAmount: 85.5,
    createdAt: "2024-08-20T14:00:00Z",
    status: "delivered",
    trackingId: null,
    products: [
      {
        productId: "p3",
        productName: "Black Leather Boots",
        productImage: "https://via.placeholder.com/100",
        quantity: 1,
        price: 85.5
      }
    ]
  }
];

const OrderPage = () => {
  const [orders, setOrders] = useState([]);

  const fetchOrders = () => {
    setOrders(mockOrders);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Format the order status for cleaner display
  const formatOrderStatus = (status) => {
    switch (status) {
      case "processing":
        return "Processing";
      case "shipped":
        return "Shipped";
      case "delivered":
        return "Delivered";
      case "cancelled":
        return "Cancelled";
      default:
        return "Unknown";
    }
  };

  return (
    <Layout>
      <Container style={{ marginTop: "40px" }}>
        <h2>Your Orders</h2>
        {orders.length === 0 ? (
          <p>You haven't placed any orders yet.</p>
        ) : (
          orders.map((order) => (
            <Card className="mb-3" key={order._id}>
              <Card.Body>
                <Row>
                  <Col md={8}>
                    <h5>Order #{order._id}</h5>
                    <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                      <strong>Order Date:</strong>{" "}
                      {new Date(order.createdAt).toLocaleDateString()}
                    </p>
                    <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                      <strong>Total:</strong> ${order.totalAmount.toLocaleString("en-US")}
                    </p>
                    <p style={{ fontSize: "14px", marginBottom: "8px" }}>
                      <strong>Status:</strong>{" "}
                      {formatOrderStatus(order.status)}
                    </p>
                    <Link to={`/order/${order._id}`}>
                      <Button
                        variant="primary"
                        style={{
                          padding: "6px 12px",
                          fontSize: "14px",
                          borderRadius: "20px",
                        }}
                      >
                        View Order Details
                      </Button>
                    </Link>
                  </Col>

                  <Col md={4} className="text-right">
                    <h6>Track Order</h6>
                    <div style={{ marginBottom: "10px" }}>
                      <span style={{ fontSize: "14px" }}>
                        Status: {formatOrderStatus(order.status)}
                      </span>
                    </div>
                    <Button
                      variant="outline-info"
                      onClick={() =>
                        window.open(
                          `https://track-order.com/${order.trackingId}`,
                          "_blank"
                        )
                      }
                      disabled={!order.trackingId}
                      style={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        borderRadius: "20px",
                      }}
                    >
                      Track your package
                    </Button>
                  </Col>
                </Row>

                {/* Render each product in the order */}
                <Row className="mt-4">
                  {order.products.map((product) => (
                    <Col
                      md={3}
                      key={product.productId}
                      className="mb-2"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Card
                        className="product-card"
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <Card.Img
                          variant="top"
                          src={product.productImage}
                          alt={product.productName}
                          style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                        <Card.Body style={{ padding: "10px" }}>
                          <Card.Title
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginBottom: "8px",
                            }}
                          >
                            {product.productName}
                          </Card.Title>
                          <p style={{ fontSize: "13px", marginBottom: "5px" }}>
                            Quantity: {product.quantity}
                          </p>
                          <p style={{ fontSize: "13px", marginBottom: "5px" }}>
                            Price: ${product.price}
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          ))
        )}
      </Container>
    </Layout>
  );
};

export default OrderPage;
